import React from 'react';

import { flagStyles } from '../settings';

const SvgBN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-624px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBN;
